import React, { forwardRef, InputHTMLAttributes } from "react";
import { useFormFieldState } from "../FormComponentHooks";
import styles from "./FormField.module.less";
import { extractValueProps, FormFieldProps } from "./FormFieldProps";

export type InputBooleanProps =
// value needs to be omitted, because boolean override is not allowed
  & Omit<InputHTMLAttributes<HTMLInputElement>, "value">
  & FormFieldProps<boolean>
  & { placeholderElement?: React.JSX.Element };

export const InputBoolean = forwardRef<HTMLInputElement, InputBooleanProps>(
  function InputBoolean(props, ref) {
    const [valueProps, { placeholder, ...inputProps }] = extractValueProps(props);
    const [value, setValue] = useFormFieldState(valueProps, false);

    return (
      <div className={styles.checkboxContainer}>
        <input
          ref={ref}
          type="checkbox"
          className={styles.checkbox}
          {...inputProps}
          checked={value}
          onChange={(e) => setValue(e.target.checked)}
        />
        <span className={styles.placeholder}>
          {placeholder}
          {" "}
          {inputProps.placeholderElement}
        </span>
      </div>
    );
  },
);
